import PageNumbers from './PageNumbers';
import PageSelector from './PageSelector';
import { PageDetails, PaginationContainer } from './styled';
import { PaginationProps } from './types';
import { getPageNumberSectionText } from './utils';

const Pagination = (paginationProps: PaginationProps): JSX.Element => {
  return (
    <PaginationContainer data-testid="paginationContainer">
      <PageDetails>
        {getPageNumberSectionText(
          paginationProps.currentPage,
          paginationProps.entriesPerPage,
          paginationProps.totalEntries
        )}
      </PageDetails>
      <PageNumbers {...paginationProps} />
      <PageSelector {...paginationProps} />
    </PaginationContainer>
  );
};

export default Pagination;
